import React from 'react';
import { useTranslation } from 'react-i18next';
import TimerDisplay from './TimerDisplay';
import OrderItem from './OrderItem';
import { getUrgency } from '../../utils/kitchenConfig';
import './OrderCard.css';

const OrderCard = ({ order, isNew, onStartItem, onCompleteItem, onResetItem, onBumpOrder }) => {
  const { t } = useTranslation();
  const orderAge = order.orderAge != null
    ? order.orderAge
    : Math.floor((Date.now() - new Date(order.orderTime)) / 60000);
  const urgency = getUrgency(orderAge);
  const allItemsReady = order.items && order.items.length > 0 && order.items.every((item) => item.status === 'ready');

  return (
    <div
      className={`order-card order-card--${urgency} ${allItemsReady ? 'order-card--all-ready' : ''} ${isNew ? 'order-card--new' : ''}`}
    >
      <div className="order-card__header">
        <div className="order-card__table">
          <span className="order-card__table-icon" aria-hidden>🍽</span>
          <span className="order-card__table-number">{t('kitchen.tableWithNumber', { number: order.tableNumber ?? 'N/A' })}</span>
        </div>
        <TimerDisplay orderTime={order.orderTime} status={order.status} />
      </div>
      <div className="order-card__items">
        {order.items && order.items.map((item) => (
          <OrderItem
            key={item.id}
            item={item}
            orderId={order.id}
            onStart={onStartItem}
            onComplete={onCompleteItem}
            onReset={onResetItem}
          />
        ))}
      </div>
      {order.notes && (
        <div className="order-card__notes">
          <span className="order-card__notes-icon">📝</span>
          <span className="order-card__notes-text">{order.notes}</span>
        </div>
      )}
      {allItemsReady && (
        <button
          type="button"
          className="order-card__bump"
          onClick={() => onBumpOrder(order.id)}
        >
          ✓ {t('kitchen.bumpOrder')}
        </button>
      )}
    </div>
  );
};

export default OrderCard;
